export const enum StatusStakingNFTEnum {
  DISABLE = 0,
  ENABLE = 1,
}

export const statusOptions = [
  {
    value: StatusStakingNFTEnum.DISABLE,
    label: 'Disable',
  },
  {
    value: StatusStakingNFTEnum.ENABLE,
    label: 'Enable',
  },
]

export enum StakingNFTPoolType {
  USDC = 'USDC',
  MEY = 'MEY',
}

export const stakingPoolTypeOptions = [
  { value: StakingNFTPoolType.USDC, label: 'USDC' },
  { value: StakingNFTPoolType.MEY, label: 'MEY' },
]

export const stakingNFTDurationOptions = [
  process.env.REACT_APP_APP_NAME !== 'MeyFi_Production'
    ? { value: 3600, label: '1 hour (Test only)' }
    : undefined,
  { value: 7776000, label: '3 Months' },
  { value: 15552000, label: '6 Months' },
  { value: 23328000, label: '9 Months' },
  { value: 31536000, label: '12 Months' },
]
